
import React from "react";

export const TickIcon = () => {
    return <svg className="w-8 h-8 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 80 80">
        <rect x="0" y="0" width="60" height="60" rx="40" ry="40" fill="#BAE2E1"></rect>
        <path fill="#30A9A6" fillRule="evenodd" d="M9.71 11.29a1 1 0 0 0-1.42 1.42l3 3A1 1 0 0 0 12 16a1 1 0 0 0 .72-.34l7-8a1 1 0 0 0-1.5-1.32L12 13.54z" clipRule="evenodd" transform="translate(-5, 0) scale(2.5)"></path></svg>

}